<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Nathaniel Cameron is a former paratrooper, boxer, inventor, entrepreneur, chemist, and practiced medicine for over 30 years. This is his first novel, it’s an international political thriller that begins with pursuit of a 3000-year-old treasure, and ends in transfiguration.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?4f891500